/**
 * Env-aware docs base URL. Every docs link in the app routes through here.
 * The docs are ONE source (the hookmyapp/mintlify-docs repo) served as three
 * instances of the same content:
 *   local   → mint dev on that repo         (VITE_DOCS_URL=http://localhost:3457, docker-compose)
 *   staging → staging-docs.hookmyapp.com    (mint export → nginx Cloud Run, deploy-staging.yml)
 *   prod    → docs.hookmyapp.com            (Mintlify hosting; unset var falls back here)
 */
const DOCS_BASE: string = import.meta.env.VITE_DOCS_URL || 'https://docs.hookmyapp.com';

export function docsUrl(path = ''): string {
  return path ? `${DOCS_BASE}/${path.replace(/^\//, '')}` : DOCS_BASE;
}
